import React from 'react';
import whiteLogo from '../assets/whitelogo.png';
import blueLogo from '../assets/bluelogo.png';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      {/* White logos */}
      <img src={whiteLogo} alt="" className="floating-logo white-logo logo-1" />
      <img src={whiteLogo} alt="" className="floating-logo white-logo logo-2" />
      <img src={whiteLogo} alt="" className="floating-logo white-logo logo-3" />
      <img src={whiteLogo} alt="" className="floating-logo white-logo logo-4" />
      <img src={whiteLogo} alt="" className="floating-logo white-logo logo-5" />
      
      {/* Blue logos */}
      <img src={blueLogo} alt="" className="floating-logo blue-logo logo-6" />
      <img src={blueLogo} alt="" className="floating-logo blue-logo logo-7" />
      <img src={blueLogo} alt="" className="floating-logo blue-logo logo-8" />
      <img src={blueLogo} alt="" className="floating-logo blue-logo logo-9" />
      <img src={blueLogo} alt="" className="floating-logo blue-logo logo-10" />
    </div>
  );
};

export default AnimatedBackground;

